const USER = {
  SET_USER_DATA: 'user/set_data',
  SET_TEST_USER_DATA: 'user/set_test_data',
};

const initialState = {};

export const setTestUserData = (data) => ({
  type: USER.SET_TEST_USER_DATA,
  payload: data,
});

export const setUserData = (data) => ({
  type: USER.SET_USER_DATA,
  payload: data,
});

const userReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER.SET_USER_DATA:
      return {
        ...state,
        ...payload,
      };

    case USER.SET_TEST_USER_DATA:
      return {
        ...state,
        testUsers: {
          ...state.testUsers,
          [payload.id]: {
            ...payload.user.user,
            shippingAddress: payload.user.shippingAddress,
            billing: payload.user.billing,
          },
        },
      };

    default:
      return state;
  }
};

export default userReducer;
